// Used to render buttons in whatsapp template preview

import { Icon } from "@iconify/react";

const renderButtons = (buttonArray) => {
  let buttons = [];

  buttonArray.forEach((button, index, arr) => {
    // Show "See all options" as third button when there are more than 3 button components
    if (arr.length > 3 && index === 3) {
      buttons.splice(
        2,
        1,
        <button className="cta-button">
          <Icon height="18" icon="material-symbols:list" />
          See all options
        </button>
      );
    } else {
      if (button.buttonType === "QUICK_REPLY") {
        buttons.push(
          <button className="quick-reply-button" key={index}>
            <Icon height="18" icon="mdi:reply" />
            {button.buttonPlaceholder}
          </button>
        );
      } else if (
        button.buttonType === "PHONE_NUMBER" ||
        button.buttonType === "URL"
      ) {
        buttons.push(
          <button className="cta-button">
            <Icon
              height="18"
              icon={
                button.buttonType === "PHONE_NUMBER"
                  ? "ic:round-local-phone"
                  : "charm:link-external"
              }
            />

            {button.buttonPlaceholder}
          </button>
        );
      } else if (button.buttonType === "none") {
        buttons.splice(index, 1);
      }
    }
  });

  return buttons;
};

export default renderButtons;
